export interface RateInfo {
  energyOnlyRate: number;
  demandRate: number;
  blendedEffectiveRate: number;
  rateConfirmed: boolean;
  notes?: string;
}

export interface DemandBaseline {
  historicalAvgKw: number;
  targetBaselineKw: number;
  alertThresholdKw: number;
  monthsAboveTarget: number;
  monthsBelowTarget: number;
}

export interface UtilityAccount {
  id: string;
  organizationId: string;
  buildingId: string;
  programId: string;
  accountNumber: string;
  label: string;
  utilityProvider?: string;
  tariffSchedule?: string;
  rateInfo: RateInfo;
  demandBaseline: DemandBaseline;
  createdBy: string;
  updatedBy: string;
  createdAt: string;
  updatedAt: string;
  isDeleted: boolean;
}

export interface UtilityBill {
  id: string;
  organizationId: string;
  buildingId: string;
  accountId: string;
  year: number;
  month: number;
  billingPeriodStart?: string;
  billingPeriodEnd?: string;
  billingDays?: number;
  kwh: number;
  energyCost: number;
  peakKw: number;
  demandCost: number;
  totalCost: number;
  notes?: string;
  createdBy: string;
  updatedBy: string;
  createdAt: string;
  updatedAt: string;
}

export const MONTH_NAMES = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const emptyRateInfo = (): RateInfo => ({
  energyOnlyRate: 0,
  demandRate: 0,
  blendedEffectiveRate: 0,
  rateConfirmed: false,
  notes: '',
});

export const emptyDemandBaseline = (): DemandBaseline => ({
  historicalAvgKw: 0,
  targetBaselineKw: 0,
  alertThresholdKw: 0,
  monthsAboveTarget: 0,
  monthsBelowTarget: 0,
});
